/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs';
// eslint-disable-next-line no-unused-vars
import React from 'react';

const isEmpty = (obj) =>
  [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
const removeProperty =
  (prop) =>
  ({ [prop]: _, ...rest }) =>
    rest;
const formatDateForClient = (date = new Date()) => {
  return dayjs(date).format('DD.MM.YYYY');
};
const formatDateForServer = (date = new Date()) => {
  return dayjs(date, 'DD.MM.YYYY').format('YYYY.MM.DD');
};

const formatMoney = (amount, decimalCount = 2, decimal = ',', thousands = '.') => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)),
      10,
    ).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  } catch (e) {
    console.log(e);
    return null;
  }
};

export { isEmpty, removeProperty, formatDateForClient, formatDateForServer, formatMoney };
